<template>
  <div class="soa-dashboard">
    <div class="appshell" :class="{ 'wb-two-col': shell.wbTwoCol }">
      <Sidebar />
      <button id="navbackdrop" type="button" class="navbackdrop" :class="{ open: shell.navOpen }" :aria-label="t('nav_close')" @click="closeMobileNav"></button>
      <div class="mainwrap" :inert="shell.navOpen">
        <Topbar />
        <div v-if="shellError" class="empty" role="alert">{{ shellError }} <button type="button" class="atbtn" @click="retryShell">{{ t("account_retry") }}</button></div>
        <main id="main-content" class="main" tabindex="-1"><slot /></main>
        <footer class="app-footer"></footer>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, watch } from "vue";

import Sidebar from "./Sidebar.vue";
import Topbar from "./Topbar.vue";
import { closeNav, shell } from "../shellState";
import { brandState, loadBrands } from "../stores/brands";
import { startMayaUnreadPolling, stopMayaUnreadPolling } from "../stores/mayaUnread";  // GEO_EXEC_R19
import { startDistributionProbe } from "../stores/distribution";  // GEO_EXEC_R14
import { notifications, refreshNotifications } from "../stores/notifications";
import { useI18n } from "../useI18n";

const { t } = useI18n();
const shellError = computed(() => brandState.error || notifications.error);

function retryShell() {
  loadBrands().catch(() => {});
  refreshNotifications().catch(() => {});
}

function closeMobileNav() {
  closeNav();
  requestAnimationFrame(() => document.getElementById("nav-toggle")?.focus());
}

function handleNavKeys(event) {
  if (!shell.navOpen) return;
  if (event.key === "Escape") {
    event.preventDefault();
    closeMobileNav();
    return;
  }
  if (event.key !== "Tab") return;
  const focusable = [...(document.getElementById("appsidebar")?.querySelectorAll('a[href], button:not([disabled])') || [])];
  if (!focusable.length) return;
  const first = focusable[0], last = focusable[focusable.length - 1];
  if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
  else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
}

onMounted(() => {
  retryShell();
  startMayaUnreadPolling().catch(() => {});  // GEO_EXEC_R19: no-op (and no interval) while off
  startDistributionProbe();  // GEO_EXEC_R14: one list request once a brand exists, then the entry is decided
  document.addEventListener("keydown", handleNavKeys);
});
onBeforeUnmount(() => {
  stopMayaUnreadPolling();  // GEO_EXEC_R19
  document.removeEventListener("keydown", handleNavKeys);
});
watch(() => shell.navOpen, (open) => {
  if (open) requestAnimationFrame(() => document.querySelector("#appsidebar a[href]")?.focus());
});
</script>
